/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsErrors } from './evidence-with-payments-errors';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsFile } from './evidence-with-payments-file';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsInvoiceIssuer } from './evidence-with-payments-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsPaymentsInner } from './evidence-with-payments-payments-inner';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsUpdatedBy } from './evidence-with-payments-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsUploadedBy } from './evidence-with-payments-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWithPaymentsWarnings } from './evidence-with-payments-warnings';

/**
 * 
 * @export
 * @interface EvidenceWithPayments
 */
export interface EvidenceWithPayments {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'id': string;
    /**
     * This is set if the payment type of the evidence is CARD_TRANSACTION. Otherwise, null.
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'paymentType': EvidenceWithPaymentsPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'electronicMethod': EvidenceWithPaymentsElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'documentSize': EvidenceWithPaymentsDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceWithPayments
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'legalValidity': EvidenceWithPaymentsLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceWithPayments
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceWithPaymentsFile}
     * @memberof EvidenceWithPayments
     */
    'file': EvidenceWithPaymentsFile;
    /**
     * 
     * @type {Array<EvidenceWithPaymentsPaymentsInner>}
     * @memberof EvidenceWithPayments
     */
    'payments': Array<EvidenceWithPaymentsPaymentsInner>;
    /**
     * 
     * @type {EvidenceWithPaymentsInvoiceIssuer}
     * @memberof EvidenceWithPayments
     */
    'invoiceIssuer': EvidenceWithPaymentsInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceWithPaymentsErrors}
     * @memberof EvidenceWithPayments
     */
    'errors': EvidenceWithPaymentsErrors;
    /**
     * 
     * @type {EvidenceWithPaymentsWarnings}
     * @memberof EvidenceWithPayments
     */
    'warnings': EvidenceWithPaymentsWarnings;
    /**
     * 
     * @type {EvidenceWithPaymentsUpdatedBy}
     * @memberof EvidenceWithPayments
     */
    'updatedBy': EvidenceWithPaymentsUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceWithPaymentsUploadedBy}
     * @memberof EvidenceWithPayments
     */
    'uploadedBy': EvidenceWithPaymentsUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWithPayments
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceWithPayments
     */
    'deleted': boolean;
}

export const EvidenceWithPaymentsPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceWithPaymentsPaymentTypeEnum = typeof EvidenceWithPaymentsPaymentTypeEnum[keyof typeof EvidenceWithPaymentsPaymentTypeEnum];
export const EvidenceWithPaymentsElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsElectronicMethodEnum = typeof EvidenceWithPaymentsElectronicMethodEnum[keyof typeof EvidenceWithPaymentsElectronicMethodEnum];
export const EvidenceWithPaymentsDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWithPaymentsDocumentSizeEnum = typeof EvidenceWithPaymentsDocumentSizeEnum[keyof typeof EvidenceWithPaymentsDocumentSizeEnum];
export const EvidenceWithPaymentsLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceWithPaymentsLegalValidityEnum = typeof EvidenceWithPaymentsLegalValidityEnum[keyof typeof EvidenceWithPaymentsLegalValidityEnum];


